import React from 'react';
import { Stack } from '@fluentui/react';
import {
  FluentIconsProps,
  Shield16Regular,
  Shield20Regular,
  ShieldTask16Filled,
  ShieldTask20Filled,
  Warning16Filled,
  Warning20Filled,
} from '@fluentui/react-icons';
import clsx from 'clsx';
import { Text } from 'common/components/Text';
import { useScreen } from 'common/hooks/useScreen';

import { stackTokens, useTagStyles } from './Tag.styles';
import { ITagProps, TagState } from './Tag.types';

type IIconMap = {
  [key in TagState]: React.FC<FluentIconsProps> | null;
};

const iconMap: IIconMap = {
  Green: ShieldTask20Filled,
  Yellow: Shield20Regular,
  Red: Warning20Filled,
  Grey: null,
  TimeRange: null,
};

const mobileIconMap: IIconMap = {
  Green: ShieldTask16Filled,
  Yellow: Shield16Regular,
  Red: Warning16Filled,
  Grey: null,
  TimeRange: null,
};

export const Tag: React.FC<ITagProps> = (props: ITagProps) => {
  const { text, state, subtle, className, variant } = props;
  const { classNames, iconColor } = useTagStyles(state, subtle, variant);
  const { isMobileScreen } = useScreen();

  let Icon: React.FC<FluentIconsProps> | null = null;

  if (state) {
    Icon = isMobileScreen ? mobileIconMap[state] : iconMap[state];
  }

  return (
    <Stack horizontalAlign="start">
      <Stack
        className={clsx(classNames.root, className)}
        horizontal
        verticalAlign="center"
        horizontalAlign="center"
        verticalFill
        tokens={stackTokens}
      >
        {Icon && (
          <Stack disableShrink verticalAlign="center">
            <Icon primaryFill={iconColor} />
          </Stack>
        )}
        <Stack.Item>
          <Text block className={classNames.text}>
            {text}
          </Text>
        </Stack.Item>
      </Stack>
    </Stack>
  );
};
